import React from 'react'

const DataProcessing = () => {
  return (
    <div>
      Data Processing
    </div>
  )
}

export default DataProcessing
